import sdkProvider from "src/utilities/sdkProvider";
import { IDENTITY_TIMEOUT } from "src/app/constants";

export default async function getCustomerAuthHeader() {
  const { getAuthHeader } = await sdkProvider("identity");
  return await getAuthHeader({ timeoutMs: IDENTITY_TIMEOUT });
}
